import morphism, { StrictSchema } from 'morphism'

import ClientSSRInterface from '../../interfaces/client/SSR'
import ServerSSRTranslationInterface from '../../interfaces/server/SSRTranslation'
import ServerSSRTranslatedInterface from '../../interfaces/server/SSRTranslated'

import translatedSSRSchema from '../../schemas/client/SSRTranslated'

export default (
  ssrs: ClientSSRInterface[],
  translations: ServerSSRTranslationInterface[]
) =>
  ssrs.map((ssr: ClientSSRInterface) => {
    const findSSRTranslationByCode = (
      ssrTranslation: ServerSSRTranslationInterface
    ) => ssrTranslation.Code === ssr.id
    const translation = translations.find(findSSRTranslationByCode)

    if (!translation) return ssr

    return morphism<
      StrictSchema<ClientSSRInterface, ServerSSRTranslatedInterface>
    >(translatedSSRSchema, {
      ...ssr,
      ...translation,
    })
  })
